import VoucherDetail from "../../components/Voucher/VoucherDetail";

const VoucherDetailPage = () => {
  return <div>
    <VoucherDetail />
  </div>;
};

export default VoucherDetailPage;
